import store from '../redux/store';

// eslint-disable-next-line import/prefer-default-export
export const injectSatismeter = () => {
  const userStore = store.getState().user;
  return window.satismeter({
    writeKey: process.env.SATISMETER_API_KEY,
    userId: userStore.pk,
    traits: {
      name: `${userStore.first_name} ${userStore.last_name}`,
      email: userStore.email,
    },
  });
};
